import { Injectable, InjectionToken, inject } from '@angular/core';
import { ScriptLoaderService } from '../../services/script-loader.service';
/**
 * This Service is used to import the analytics code from the external url provided in the configuration.
 */

export const ANALYTICS_CONFIGURATION = new InjectionToken<AnalyticsConfiguration>('analyticsConfiguration');

export interface AnalyticsConfiguration {
  analyticsDisabled: boolean;
  analyticsUrl: string;
  initDelay?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private readonly scriptLoader = inject(ScriptLoaderService);
  private readonly analyticsConfiguration = inject<AnalyticsConfiguration>(ANALYTICS_CONFIGURATION, { optional: true });

  private static readonly DEFAULT_INIT_DELAY: number = 1000;

  init(): void {
    if (this.analyticsConfiguration !== null && !this.analyticsConfiguration.analyticsDisabled) {
      this.bootstrap(this.analyticsConfiguration.analyticsUrl,
        this.analyticsConfiguration.initDelay ?? AnalyticsService.DEFAULT_INIT_DELAY);
    }
  }

  //TODO: move into script-loader.service.ts
  private bootstrap(url: string, initDelay: number): void {
    if (url !== undefined && url !== null) {
      setTimeout((): void => {
        this.scriptLoader.load(url);
      }, initDelay);
    }
  }
}
